module.exports = __webpack_public_path__ + "static/img/bg1.a1ef2d0d.png";